import type { CampaignStatus, Json } from '@deltasuite/supabase-client';
import { dialApiFetch, isDialApiConfigured } from './client';

export interface Campaign {
  id: string;
  created_by: string;
  name: string;
  description: string | null;
  starts_at: string | null;
  ends_at: string | null;
  audience_filter: Json | null;
  script: string | null;
  email_template_id: string | null;
  point_goal: number | null;
  status: CampaignStatus;
  is_mine?: boolean;
  is_assigned_to_me?: boolean;
  created_at: string;
  updated_at: string;
}

export interface QueuedForMeRow {
  campaign_id: string;
  assigned_at: string;
  campaigns: {
    id: string;
    name: string;
    description: string | null;
    starts_at: string | null;
    ends_at: string | null;
    point_goal: number | null;
    status: CampaignStatus;
    script: string | null;
    email_template_id: string | null;
  };
}

export async function listCampaigns(): Promise<Campaign[]> {
  if (!isDialApiConfigured) return [];
  const { rows } = await dialApiFetch<{ rows: Campaign[] }>('/v1/campaigns');
  return rows;
}

export async function listQueuedForMe(): Promise<QueuedForMeRow[]> {
  if (!isDialApiConfigured) return [];
  const { rows } = await dialApiFetch<{ rows: QueuedForMeRow[] }>('/v1/campaigns/queued-for-me');
  return rows;
}

export interface CampaignCreateInput {
  name: string;
  description?: string;
  starts_at?: string;
  ends_at?: string;
  audience_filter?: Json;
  script?: string;
  email_template_id?: string;
  point_goal?: number;
}

export async function createCampaign(input: CampaignCreateInput): Promise<Campaign> {
  return dialApiFetch<Campaign>('/v1/campaigns', { method: 'POST', body: input });
}

export async function assignCampaign(
  campaignId: string,
  userIds: readonly string[],
): Promise<{ assigned: number }> {
  return dialApiFetch(`/v1/campaigns/${campaignId}/assignments`, {
    method: 'POST',
    body: { user_ids: userIds },
  });
}
